import React, { Component } from "react";
import { connect } from "react-redux";
import powerImg from "../../images/power.png";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  logout() {
    const keycloak = this.props.posts.map((post) => post.keycloak);
    const realm = this.props.posts.map((post) => post.realm);
    const id_token = this.props.posts.map((post) => post.id_token);

    try {
      keycloak.logout();
    } catch (error) {
      window.location =
        process.env.REACT_APP_KEYCLOAK_URL +
        "/realms/" +
        realm +
        "/protocol/openid-connect/logout?" +
        "post_logout_redirect_uri=" +
        window.location.origin +
        "&id_token_hint=" +
        id_token;
    }
  }

  render() {
    const buttonStyle = {
      flex: 1,
      padding: '8px 16px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: 500,
      fontSize: '14px'
    };

    const logoutButtonStyle = {
      ...buttonStyle,
      backgroundColor: '#dc3545',
      color: 'white'
    };

    const cancelButtonStyle = {
      ...buttonStyle,
      backgroundColor: '#0d6efd',
      color: 'white'
    };

    return (
      <>
        {/* <button
          type="button"
          onClick={this.toggleModal}
          style={{
            padding: '10px 15px',
            marginLeft: '15px',
            borderRadius: '100px',
          }}
        >
          <img alt="Logout" src="images/Icon-down.png" />
        </button> */}

      <button
        style={{
            backgroundColor: "#E5E5EA",
            padding: "10px 15px 10px 15px",
            marginLeft: "15px",
            borderRadius: "100px",
            marginRight: "4px",
            border: "none"
            
          }}
          onClick={this.toggleModal}
        >
          {/* <i className="bi bi-box-arrow-right"></i> */}
          <img alt="Logout" src={powerImg} width={20}/>
        </button>

        <div
          className={`modal fade ${this.state.showModal ? 'show d-block' : ''}`}
          tabIndex="-1"
          style={{ backgroundColor: this.state.showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Confirm Logout</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={this.toggleModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                Are you sure you want to log out?
              </div>
              <div className="modal-footer border-0" style={{ display: 'flex', gap: '10px' }}>
                <button
                  type="button"
                  style={cancelButtonStyle}
                  onClick={this.toggleModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={logoutButtonStyle}
                  onClick={() => {
                    this.logout();
                    this.toggleModal();
                  }}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Logout);